// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import type {
  IIconStyleProps,
  IIconStyles,
  IStyleFunctionOrObject,
} from "@fluentui/react";

const numericProperties = [
  "zIndex",
  "fontWeight",
  "gridColumn",
  "opacity",
  "columnCount",
  "order",
  "flexShrink",
  "flexGrow",
];

/**
 * Converts a legacy IStyle rule into CSS properties
 * that can be used for inline styles
 */
export const convertToCssObject = (rule: Object) => {
  if (rule === undefined) return {};

  const cssObj: { [key: string]: any } = {};
  for (const [property, value] of Object.entries(rule)) {
    // skip selectors/nested styles
    if (property === "selectors") continue;

    if (typeof value === "number" && !numericProperties.includes(property)) {
      cssObj[property] = `${value}px`;
    } else {
      cssObj[property] = value;
    }
  }
  return cssObj as React.CSSProperties;
};

/**
 * Convert styles of type IStyleFunctionOrObject to CSS Properties
 * that can be used for inline styles.
 * @param styles
 * @returns CSSProperties or null in case styles or root property is not present
 */
export function convertStyleFunctOrObjectToCSSProperties(
  styles?: IStyleFunctionOrObject<IIconStyleProps, IIconStyles>
): React.CSSProperties | undefined {
  if (!styles) {
    return undefined;
  }
  const iconStyles =
    typeof styles === "function" ? styles({} as IIconStyleProps) : styles;
  return iconStyles.root ? convertToCssObject(iconStyles.root) : undefined;
}
